import styled from "styled-components";

const PadLeft  = styled.span`
padding-left: 10px;
`;

const SpanPadLeft = ({Title}) => {
    return <PadLeft><b>{Title}</b></PadLeft>;
  };
  
export default SpanPadLeft;